export default __webpack_public_path__ + "static/media/GPA_Banner_CommunityPartners.e1c1aef2.png";